import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { LetModule } from '@ngrx/component';
import { BehaviorSubject } from 'rxjs';

import { TooltipPosition } from '../../models/_table.model';

@Component({
  standalone: true,
  imports: [AsyncPipe, LetModule],
  selector: 'tsq-table-tooltip',
  template: `
    <div
      *ngrxLet="position$ as position"
      class="tooltip-content relative max-w-[200px] rounded bg-white p-8 shadow transition-all"
      [style.opacity]="position ? 1 : 0"
      [attr.position]="position"
    >
      {{ text$ | async }}
    </div>
  `,
  styleUrls: ['./table-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableTooltipComponent {
  private readonly textSubject = new BehaviorSubject<string>('');
  protected readonly text$ = this.textSubject.asObservable();

  private readonly positionSubject = new BehaviorSubject<TooltipPosition | null>(null);
  protected readonly position$ = this.positionSubject.asObservable();

  setText(text: string): void {
    this.textSubject.next(text);
  }

  setPosition(position: TooltipPosition): void {
    this.positionSubject.next(position);
  }
}
